import { IsProduction, RouterPaths } from 'utils/constant'
import { URL, Authorization } from "./constant"
import { getStorage } from "./localstorage"
import { clearLoginInfo } from "service/sign"
import ModelFn from "components/model/ModelFn"
import { isMobile } from 'utils/utils'

// const codeMessage = {
//   200: '服务器成功返回请求的数据。',
//   201: '新建或修改数据成功。',
//   202: '一个请求已经进入后台排队（异步任务）。',
//   204: '删除数据成功。',
//   400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
//   401: '用户没有权限（令牌、用户名、密码错误）。',
//   403: '用户得到授权，但是访问是被禁止的。',
//   404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
//   406: '请求的格式不可得。',
//   410: '请求的资源被永久删除，且不会再得到的。',
//   422: '当创建一个对象时，发生一个验证错误。',
//   500: '服务器发生错误，请检查服务器。',
//   502: '网关错误。',
//   503: '服务不可用，服务器暂时过载或维护。',
//   504: '网关超时。',
// }

// const checkStatus = async response => {
//   if (response.status >= 200 && response.status < 300) {
//     return response
//   }
//   const errortext = codeMessage[response.status] || response.statusText
//   const error = new Error(errortext)
//   error['status'] = response.status
//   error['response'] = response
//   try {
//     error['data'] = await response.json()
//   } catch (e) {
    
//   }
//   throw error
// }

function loginTimeout () {
  clearLoginInfo()
  ModelFn.confirm({ 
    text: "请先登录穿梭账号", 
    onConfirm: () => { isMobile() ? window.location.replace(RouterPaths["signin-phone"]) : window.location.replace(RouterPaths["signin-qr"]) },
    noCancel: true
  })
}

export function request(path: string, option) {
  let url
  if(path.includes('/api/1/') || path.includes('/api/2/')){
    url = path
  }else{
    url = URL + path
  }
  // const url = URL + path
  const Auth = getStorage(Authorization)
  const headers = {}

  if (Auth) {
    headers['Authorization'] = `Bearer ${Auth}`
  }

  const options = {
    mode: 'cors',
    headers,
    ...option
  }
  
  if (
    options.method === 'POST' ||
    options.method === 'PUT' ||
    options.method === 'DELETE'
  ) {
    options.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      ...options.headers,
    }
    options.body = JSON.stringify(options.body)
  }

  return fetch(url, options)
    .then(async response => {
      let data: any = {}
      // DELETE and 204 do not return data by default
      // using .json will report an error.
      if (options.method === 'DELETE' || response.status === 204 || response.status === 504 || response.status === 502) {
        data = response.text()
        return data
      }
      // 登录过期
      if (response.status === 401) {
        loginTimeout()
      }

      data = await response.json()
      if (!IsProduction) {
        // console.group(url)
        // console.log(data)
        console.groupEnd()
      }
      return data
    })
    .catch(e => {
      console.error(`url: ${path}, message: ${e.message}`)
      console.error(e)
      throw e
    })
}

export async function get(url: string, options) {
  options = { ...options, method: 'GET' }
  const data = await request(url, options)
  return data
}

export async function post(url: string, options) {
  options = { ...options, method: 'POST' }
  const data = await request(url, options)
  return data
}

export async function del(url: string, options) {
  options = { ...options, method: 'DELETE' }
  const data = await request(url, options)
  return data
}
